module.exports = __webpack_public_path__ + "img/qiandao.626aceef.png";